<template>
  <div id="friend">
    <div class="banner">
    </div>
    <div class="home_fr">
      <section>
        <div v-for="(ele,index) in frlist" :key="index" :class="{nomargin: index % 4 == 0}">
          <img :src="ele" alt="">
        </div>
      </section>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      frlist: [
        require("../home/home_fr1.png"),
        require("../home/home_fr2.png"),
        require("../home/home_fr3.png"),
        require("../home/home_fr4.png"),
        require("../home/home_fr5.png"),
        require("../home/home_fr6.png"),
        require("../home/home_fr7.png"),
        require("../home/home_fr8.png"),
        require("../home/home_fr9.png"),
        require("../home/home_fr10.png"),
        require("../home/home_fr11.png"),
        require("../home/home_fr12.png"),
        require("../home/home_fr13.png"),
        require("../home/home_fr14.png"),
        require("../home/home_fr15.png"),
        require("../home/home_fr16.png"),
        require("../home/home_fr17.png"),
        require("../home/home_fr18.png"),
        require("../home/home_fr19.png"),
        require("../home/home_fr20.png"),
        require("../home/home_fr21.png"),
        require("../home/home_fr22.png"),
        require("../home/home_fr23.png"),
        require("../home/home_fr24.png")
      ]
    };
  },
  computed: {},
  components: {},
  created() {},
  destroyed() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="less" scoped>
#friend {
  width: 100%;
  .banner {
    width: 100%;
    height: 420px;
    background: url("./adjuz_friend.png") no-repeat center center;
    background-size: cover;
  }
  //合作伙伴
  .home_fr {
    width: 100%;
    margin: 100px 0 70px;
    section {
      width: 1200px;
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto;
      div {
        width: 20%;
        height: 96px;
        margin-bottom: 30px;
        margin-left: 6.66%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        border-radius: 10px;
        &.nomargin {
          margin-left: 0;
        }
        &:hover {
          box-shadow: 0 8px 8px 0 #e0e6e7;
          transform: translateY(-6px);
        }
      }
    }
  }
}
</style>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/page/friend/index.vue